/**
 * Contact form service using Firebase Firestore for storage
 * and Email.js for sending email notifications
 */
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import emailjs from 'emailjs-com';

// Initialize EmailJS (call this in your main app initialization)
export const initEmailJS = () => {
  // Replace with your actual EmailJS user ID
  emailjs.init("YOUR_USER_ID_HERE");
};

// Form validation functions
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePhone = (phone) => {
  const phoneRegex = /^[\+]?[0-9\s\-\(\)]{10,}$/;
  return phoneRegex.test(phone.replace(/\s/g, ''));
};

/**
 * Submit contact form data to Firestore and send email notification
 */
export const submitContactForm = async (formData) => {
  try {
    // 1. Store the form data in Firestore
    const docRef = await addDoc(collection(db, "contactSubmissions"), {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      company: formData.company || 'Not provided',
      service: formData.service || 'Not specified',
      message: formData.message,
      timestamp: serverTimestamp(),
      status: 'new'
    });

    console.log("Document written with ID: ", docRef.id);

    // 2. Send email notification using EmailJS
    const emailParams = {
      to_email: 'ndlelenimaqubela@gmail.com',
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone,
      company: formData.company || 'Not provided',
      service_interest: formData.service || 'Not specified',
      message: formData.message,
      reply_to: formData.email
    };

    // EmailJS configuration - Replace with your actual values from EmailJS dashboard
    const serviceId = 'YOUR_SERVICE_ID'; // Replace with your EmailJS service ID
    const templateId = 'YOUR_TEMPLATE_ID'; // Replace with your EmailJS template ID

    const emailResult = await emailjs.send(serviceId, templateId, emailParams);
    console.log('Email sent successfully:', emailResult.text);

    return { success: true, id: docRef.id };
  } catch (error) {
    console.error("Error submitting form:", error);
    
    // Try fallback method if primary method fails
    try {
      return await submitViaFormspree(formData);
    } catch (formspreeError) {
      console.error("Formspree fallback also failed:", formspreeError);
      return { success: false, error: error.message };
    }
  }
};

/**
 * Fallback submission using Formspree
 */
const submitViaFormspree = async (formData) => {
  try {
    // Replace this with your Formspree form ID
    const FORMSPREE_ENDPOINT = "https://formspree.io/f/yourformid";
    
    const response = await fetch(FORMSPREE_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...formData,
        _subject: `New Contact Form Submission: ${formData.name}`,
        _replyto: formData.email
      }),
    });
    
    if (response.ok) {
      return { success: true, id: new Date().getTime().toString() };
    } else {
      const errorData = await response.json();
      throw new Error(errorData.error || "Form submission failed");
    }
  } catch (error) {
    console.error("Error submitting form via Formspree:", error);
    // Try the final fallback method
    return submitViaEmail(formData);
  }
};

/**
 * Final fallback implementation using a simple mailto link
 */
export const submitViaEmail = (formData) => {
  try {
    const subject = encodeURIComponent(`Website Contact: ${formData.name}`);
    const body = encodeURIComponent(`
Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}
Company: ${formData.company || 'Not provided'}
Service: ${formData.service || 'Not specified'}
Message: ${formData.message}
    `);
    
    // Open the user's email client
    window.location.href = `mailto:ndlelenimaqubela@gmail.com?subject=${subject}&body=${body}`;
    
    return { success: true };
  } catch (error) {
    console.error("Error opening email client:", error);
    return { success: false, error: error.message };
  }
};